"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var system_1 = require("../system");
var utils_1 = require("../utils");
function getPadding(topBottom, leftRight, borderWidth) {
    if (borderWidth === void 0) { borderWidth = 0; }
    return "".concat(topBottom - borderWidth, "px ").concat(leftRight - borderWidth, "px");
}
var commonButtonStyles = {
    padding: getPadding(system_1.Spacing.S, system_1.Spacing.L),
    height: 40,
    minWidth: 40,
    position: 'relative',
    textTransform: 'none',
    transition: 'none',
};
var borderWidth = 2;
var useGoStyles = (0, system_1.makeStyles)({
    go: {},
});
var makeRoot = function (props, theme) {
    var schemes = theme.schemes, mixins = theme.mixins;
    var effects = mixins.effects;
    var colors = schemes.colors;
    var buttons = schemes.components.buttons;
    var variant = props.variant || system_1.ButtonVariants.Default;
    var buttonScheme = buttons[variant] || buttons.default;
    var common = __assign(__assign(__assign(__assign(__assign({}, commonButtonStyles), mixins.typography.Body), mixins.effects.Hovered()), mixins.effects.Pressed()), { color: buttonScheme.textColor, backgroundColor: colors.system.BgMain, borderRadius: 16, '&:focus:focus-visible': {
            border: "".concat(borderWidth, "px solid ").concat(colors.system.IconMain),
            padding: getPadding(system_1.Spacing.S, system_1.Spacing.L, borderWidth),
        }, '&[data-focus-visible-added]': {
            border: "".concat(borderWidth, "px solid ").concat(colors.system.IconMain, " !important"),
            padding: getPadding(system_1.Spacing.S, system_1.Spacing.L, borderWidth),
        } });
    switch (props.variant) {
        case system_1.ButtonVariants.Main:
            return Object.assign(common, {
                backgroundColor: colors.system.ButtonMain,
            });
        case system_1.ButtonVariants.SubtleAccent:
            return Object.assign(common, {
                backgroundColor: colors.system.SubtleAccent,
            });
        case system_1.ButtonVariants.Default:
        default:
            return Object.assign(common, {
                backgroundColor: colors.system.ButtonMinor,
            });
        case system_1.ButtonVariants.Outline:
            return Object.assign(common, {
                border: "".concat(borderWidth, "px solid ").concat(colors.system.Line),
                padding: getPadding(system_1.Spacing.S, system_1.Spacing.L, borderWidth),
            });
        case system_1.ButtonVariants.Float:
            return Object.assign(common, __assign({}, effects.ShadowBottom));
        case system_1.ButtonVariants.Plain:
            return common;
    }
};
var buttonIconStyles = {
    maxWidth: 24,
    maxHeight: 24,
};
var useStyles = (0, system_1.makeStyles)(function (theme) {
    return __assign({ root: function (props) {
            var _a;
            return (_a = {},
                // jss-nested ломается при использовании функций от пропсов
                // надо передавать класс
                _a["&.".concat(props.goClass)] = makeRoot(props, theme.go),
                _a.width = '100%',
                _a);
        }, disabled: {
            opacity: 0.6,
        }, startIcon: {
            marginRight: theme.go.schemes.spacing.units.XS,
        }, endIcon: {
            marginLeft: theme.go.schemes.spacing.units.XS,
        }, label: {
            // фиксит прыгание контента кнопки в IE 11
            position: 'relative',
            '& svg': __assign({}, buttonIconStyles),
        }, iconButton: {
            width: '40px !important',
            padding: "".concat(theme.go.schemes.spacing.units.XS, "px !important"),
        }, disableClick: {
            pointerEvents: 'none',
        } }, theme.go.mixins.effects.ButtonLoading);
});
exports.Button = react_1.default.forwardRef(function Button(props, ref) {
    var variant = props.variant, children = props.children, startIcon = props.startIcon, endIcon = props.endIcon, loading = props.loading, className = props.className, outerClasses = props.classes, rest = __rest(props, ["variant", "children", "startIcon", "endIcon", "loading", "className", "classes"]);
    var go = useGoStyles().go;
    var _a = useStyles({
        variant: variant,
        goClass: go,
    }), loadingEffect = _a.loadingEffect, iconButton = _a.iconButton, disableClick = _a.disableClick, startIconClass = _a.startIcon, endIconClass = _a.endIcon, classes = __rest(_a, ["loadingEffect", "iconButton", "disableClick", "startIcon", "endIcon"]);
    var commonProps = __assign(__assign({}, rest), { className: (0, utils_1.cn)(go, className, loading ? loadingEffect : null, loading ? disableClick : null), tabIndex: loading ? -1 : rest.tabIndex });
    if (children) {
        return (react_1.default.createElement(Button_1.default, __assign({ ref: ref }, commonProps, { startIcon: startIcon, endIcon: endIcon, classes: __assign(__assign({}, utils_1.cn.merge(classes, outerClasses)), { root: (0, utils_1.cn)(classes.root, outerClasses === null || outerClasses === void 0 ? void 0 : outerClasses.root), startIcon: (0, utils_1.cn)(startIconClass, outerClasses === null || outerClasses === void 0 ? void 0 : outerClasses.startIcon), endIcon: (0, utils_1.cn)(endIconClass, outerClasses === null || outerClasses === void 0 ? void 0 : outerClasses.endIcon) }) }), children));
    }
    return (react_1.default.createElement(IconButton_1.default, __assign({ ref: ref }, commonProps, { classes: __assign(__assign({}, utils_1.cn.merge(classes, outerClasses)), { root: (0, utils_1.cn)(iconButton, classes.root, outerClasses === null || outerClasses === void 0 ? void 0 : outerClasses.root) }) }), startIcon || endIcon));
});
